import React, { useState } from "react";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, DatePicker, Space, Card, Alert } from "antd";
import dayjs from "dayjs";

const FiscalYearArray = ({ value = [], onChange, placeholder, disabled }) => {
  const [error, setError] = useState("");

  const hasOverlap = (periods) => {
    if (periods.length < 2) return false;

    for (let i = 0; i < periods.length; i++) {
      for (let j = i + 1; j < periods.length; j++) {
        const start1 = new Date(periods[i].start);
        const end1 = new Date(periods[i].end);
        const start2 = new Date(periods[j].start);
        const end2 = new Date(periods[j].end);

        if (start1 <= end2 && start2 <= end1) {
          return true;
        }
      }
    }
    return false;
  };

  const isValidPeriod = (period) => {
    if (!period.start || !period.end) return false;
    const start = new Date(period.start);
    const end = new Date(period.end);
    return start <= end;
  };

  const addFiscalYear = () => {
    const newPeriod = {
      start: null,
      end: null,
    };

    const updatedValue = [...(value || []), newPeriod];
    onChange(updatedValue);
    setError("");
  };

  const removeFiscalYear = (index) => {
    const updatedValue = [...(value || [])];
    updatedValue.splice(index, 1);
    onChange(updatedValue);
    setError("");
  };

  const updateFiscalYear = (index, field, dateValue) => {
    const updatedValue = [...(value || [])];
    updatedValue[index][field] = dateValue
      ? dateValue.toDate().toISOString()
      : null;

    onChange(updatedValue);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      return dayjs(dateString).format("MMM DD, YYYY");
    } catch {
      return "";
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {error && (
        <Alert
          message="Validation Error"
          description={error}
          type="error"
          showIcon
          closable
          style={{ marginBottom: 16 }}
        />
      )}

      <Button
        icon={<PlusOutlined />}
        onClick={addFiscalYear}
        style={{
          width: "100%",
          height: 44,
          borderRadius: 10,
          fontWeight: 500,
          marginBottom: 16,
          backgroundColor: "#6254bf",
          borderColor: "#6254bf",
          color: "#fff",
        }}
        disabled={disabled}
      >
        Add Fiscal Year
      </Button>

      {value && value.length > 0 && (
        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          {value.map((period, index) => (
            <Card
              key={period._id?.toString() || index}
              size="small"
              style={{
                marginBottom: 12,
                borderRadius: 10,
                border: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
              }}
              extra={
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => removeFiscalYear(index)}
                  size="small"
                  disabled={disabled}
                />
              }
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                <Space
                  style={{ width: "100%", justifyContent: "space-between" }}
                >
                  <div
                    style={{
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "#6254bf",
                    }}
                  >
                    Fiscal Year {index + 1}
                  </div>
                  <div style={{ fontSize: "12px", color: "#999" }}>
                    {formatDate(period.start)} - {formatDate(period.end)}
                  </div>
                </Space>
                <Space style={{ width: "100%" }}>
                  <div style={{ flex: 1 }}>
                    <label
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        display: "block",
                        marginBottom: "4px",
                      }}
                    >
                      Start Date
                    </label>
                    <DatePicker
                      value={period.start ? dayjs(period.start) : null}
                      onChange={(date) =>
                        updateFiscalYear(index, "start", date)
                      }
                      style={{ width: "100%" }}
                      placeholder="Select start date"
                      disabled={disabled}
                      format="MMM DD, YYYY"
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        display: "block",
                        marginBottom: "4px",
                      }}
                    >
                      End Date
                    </label>
                    <DatePicker
                      value={period.end ? dayjs(period.end) : null}
                      onChange={(date) => updateFiscalYear(index, "end", date)}
                      style={{ width: "100%" }}
                      placeholder="Select end date"
                      disabled={disabled}
                      format="MMM DD, YYYY"
                    />
                  </div>
                </Space>
              </Space>
            </Card>
          ))}
        </div>
      )}

      {(!value || value.length === 0) && (
        <div
          style={{
            textAlign: "center",
            padding: "30px 20px",
            color: "#999",
            border: "2px dashed #e8e8e8",
            borderRadius: 10,
            backgroundColor: "#fafafa",
          }}
        >
          No fiscal years added. Click "Add Fiscal Year" to start.
        </div>
      )}
    </div>
  );
};

export default FiscalYearArray;
